function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { onFormSubmitFailed } from '@formily/core';
import { FormilyForm } from "../../../../components/Formily";
// import { pathToId } from '@micun/mini-form/src/components/FormItem'
import { forwardRef, memo, useCallback, useEffect, useRef, useState } from 'react';
import { usePrevious } from 'react-use';
import { jsx as _jsx } from "react/jsx-runtime";
function shallowEqual(a, b) {
  var keys = Array.from(new Set([].concat(_toConsumableArray(Object.keys(a)), _toConsumableArray(Object.keys(b)))));
  return keys.every(function (key) {
    return a[key] === b[key];
  });
}
var FormView = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$mode = props.mode,
    mode = _props$mode === void 0 ? 'readOnly' : _props$mode,
    scrollViewId = props.scrollViewId,
    schema = props.schema,
    value = props.value,
    context = props.context;
  var prevSchema = usePrevious(schema);
  var prevValue = usePrevious(value);
  var formRef = useRef();
  var schemaRef = useRef({});
  var scrollView = useRef();
  var getValue = function getValue() {
    var nextVal = {};
    try {
      nextVal = JSON.parse(value);
    } catch (e) {
      // ignore
    }
    Object.assign(nextVal, {
      _context_: _objectSpread({}, context)
    });
    return nextVal;
  };
  var _useState = useState(function () {
      return {
        pattern: mode,
        values: getValue(),
        effects: function effects(form) {
          var _props$effects;
          (_props$effects = props.effects) === null || _props$effects === void 0 || _props$effects.call(props, form);
          onFormSubmitFailed(function (_form) {
            if (!scrollView.current) {
              return;
            }
            var errors = _form.errors || [];
            if (Array.isArray(errors)) {
              // TODO: FormItem 增加 id
              console.log('id', errors[0].path);
              // const target = `#${pathToId(errors[0].path!)}`
              // scrollView.current?.scrollIntoView(target)
            }
          });
        }
      };
    }),
    _useState2 = _slicedToArray(_useState, 1),
    options = _useState2[0];
  if (prevSchema !== schema) {
    try {
      schemaRef.current = JSON.parse(schema);
    } catch (e) {
      // ignore
    }
  }
  var prevCtx = usePrevious(context);
  var ctxEqual = shallowEqual(context || {}, prevCtx || {});
  if (prevValue !== value || !ctxEqual) {
    if (formRef.current) {
      var nextValue = getValue();
      formRef.current.values = nextValue;
    }
  }
  useEffect(function () {
    if (!scrollViewId) {
      return;
    }
    var timer;
    var queryNode = function queryNode() {
      scrollView.current = document.querySelector(scrollViewId);
    };
    queryNode();
    return function () {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [scrollViewId]);
  var getRef = useCallback(function (current) {
    // @ts-ignore
    var forms = window.forms = window.forms || [];
    if (formRef.current && current == null) {
      // 卸载时从 arr 中删除
      var curId = formRef.current.id;
      var idx = forms.findIndex(function (i) {
        return i.id === curId;
      });
      if (idx > -1) {
        forms.splice(idx, 1);
      }
    }
    if (current !== null && current !== void 0 && current.id) {
      var _idx = forms.findIndex(function (i) {
        return i.id === current.id;
      });
      if (_idx === -1) {
        forms.push(current);
      } else {
        forms.splice(_idx, 1, current);
      }
    }
    formRef.current = current;
    if (typeof ref === 'function') {
      ref === null || ref === void 0 || ref(current);
    } else if (ref !== null && 'current' in ref) {
      ref.current = current;
    }
  }, [ref]);
  return /*#__PURE__*/_jsx(FormilyForm, {
    ref: getRef,
    options: options,
    schema: schemaRef.current
  });
});
FormView.displayName = 'FormView';
export default /*#__PURE__*/memo(FormView);